<template>
  <div class="flex flex-col justify-between items-center gap-6 w-full pb-8 p-4">
    <div class="flex flex-col gap-2 items-center">
      <p class="font-semibold">Connect your Wallet</p>
      <p class="text-GREY text-xs">
        Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.
      </p>
    </div>
    <div class="flex flex-col gap-6 items-center w-full">
      <pow-button size="xs" class="w-full" secondary>Open Wallet in Telegram</pow-button>
      <div class="flex flex-row justify-between gap-2 items-center w-full">
        <div
          @click="openWalletConnectConfirmDrawer(wallet)"
          v-for="(wallet, index) in wallets"
          class="flex flex-col items-center gap-2"
        >
          <div
            class="border border-1 border-LIGHTGREY w-8 h-8 rounded-lg flex flex-col justify-center items-center"
          >
            <div class="rounded-full bg-LIGHTGREY w-3 h-3"></div>
          </div>
          <p class="font-semibold text-xs max-w-[60px] truncate">{{ wallet.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PowButton from '../PowButton.vue'
import { ref } from 'vue'
import { openBottomDrawer } from '@/composables/bottomdrawer'
import ConnectWalletConfirmDrawer from './ConnectWalletConfirmDrawer.vue'

const openWalletConnectConfirmDrawer = (wallet) => {
  openBottomDrawer(ConnectWalletConfirmDrawer, {
    props: { walletInfo: wallet },
    emits: {},
    size: 'xs'
  })
}
const wallets = ref([
  {
    name: 'Tonkeeper',
    icon: 'mastercard-logo.png',
    content:
      'Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.'
  },
  {
    name: 'MyTownWallet',
    icon: 'mastercard-logo.png',
    content:
      'Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.'
  },
  {
    name: 'TonHub',
    icon: 'mastercard-logo.png',
    content:
      'Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.'
  },
  {
    name: 'Dewallet',
    icon: 'mastercard-logo.png',
    content:
      'Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.'
  },
  {
    name: 'ViewAll',
    icon: 'mastercard-logo.png',
    content:
      'Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.'
  }
])
</script>

<style lang="scss" scoped></style>
